import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { RequestPayload } from './types';
import { DMPsReportItem, EquipmentScanningReport, StandsReport, TxReport, UserActivity } from './models';
import { DmpsReport } from './models/dmp-report';
const ENDPOINT = 'reports/';

export type GetEquipmentsScanningPayload = {
  filter: {
    date_b: string,
    date_e: string,
    user?: string,
    full_name?: string,
    serial_num?: string,
    inventory_num?: string,
    model_id?: number[],
    brand_id?: number[],
    manufacturer_id?: number[],
  },
  download: boolean
}

export type GetStandsReportPayload = {
  filter: {
    date_b: string,
    date_e: string,
    director?: string,
    regional_manager?: string,
    territorial_manager?: string,
    distributor_id?: number,
    route_number_id?: number,
    outlet_id?: number,
    full_name?: string,
    stand_id?: number,
    equip_model_id?: number[],
    model_id?: number[],
    brand_id?: number[],
    manufacturer_id?: number[],
    is_active?: string,
    mount_dt?: string,
    update_dt?: string,
  },
  download: boolean
}

export type GetDMPReportPayload = {
  filter: {
    date_b: string,
    date_e: string,
    director?: string,
    regional_manager?: string,
    territorial_manager?: string,
    distributor_id?: number,
    route_number_id?: number,
    outlet_id?: number,
    full_name?: string,
    group_id?: number,
    type_id?: number,
  },
  download: boolean
}

export type GetTxReportPayload = {
  filter: {
    date_b: string,
    date_e: string,
  },
  download: boolean
}

export type GetUserActivityDashboardPayload = {
  date_b?: string,
  date_e?: string,
}

export type UserActivityDashboard = {
  visit: number,
  first_scanning: number,
  scanning: number,
  stand: number,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getEquipmentsScanning: (payload: GetEquipmentsScanningPayload) =>
    instance.post<ApiResponse<EquipmentScanningReport>>(ENDPOINT + 'equipment_scanning/', payload, config),
  getUserActivity: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', UserActivity>>>(ENDPOINT + 'user_activity/mobile/', payload, config),
  getUserActivityDashboard: (payload: GetUserActivityDashboardPayload) =>
    instance.post<ApiResponse<UserActivityDashboard>>(ENDPOINT + 'user_activity/dashboard/', payload, config),
  getTxReport: (payload: GetTxReportPayload) =>
    instance.post<ApiResponse<TxReport>>(ENDPOINT + 'transactions/', payload, config),
  getStandsReport: (payload: GetStandsReportPayload) => 
    instance.post<ApiResponse<StandsReport>>(ENDPOINT + 'stands/', payload, config),
  getDMPReport: (payload: GetDMPReportPayload) => 
    instance.post<ApiResponse<DmpsReport>>(ENDPOINT + 'stands_dmp/', payload, config),
});
